import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=0ac635ce&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=ts"
export * from "./FooterComponent.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=0ac635ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac635ce",
  null
  
)

export default component.exports